
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface ExpenseFormStateProps {
  onExpenseCreated: () => void;
  onClose: () => void;
  entityType?: 'house' | 'plot';
}

export const useExpenseFormState = ({ onExpenseCreated, onClose, entityType = 'house' }: ExpenseFormStateProps) => {
  const [selectedEntity, setSelectedEntity] = useState("");
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [expenseDate, setExpenseDate] = useState("");
  const { toast } = useToast();

  const handleCreateExpense = async () => {
    if (!selectedEntity || !amount || !category || !description || !expenseDate) {
      toast({
        title: "Error",
        description: "Por favor complete todos los campos requeridos",
        variant: "destructive",
      });
      return;
    }

    const { error } = await supabase.from("expenses").insert({
      entity_id: selectedEntity,
      entity_type: entityType,
      amount: parseInt(amount),
      category,
      description,
      expense_date: expenseDate,
    });

    if (error) {
      console.error("Error creating expense:", error);
      toast({
        title: "Error",
        description: "No se pudo crear el gasto",
        variant: "destructive",
      });
      return;
    }

    toast({
      title: "Éxito",
      description: "Gasto creado exitosamente",
    });

    onClose();
    setSelectedEntity("");
    setAmount("");
    setCategory("");
    setDescription("");
    setExpenseDate("");
    onExpenseCreated();
  };

  return {
    selectedEntity,
    setSelectedEntity,
    amount,
    setAmount,
    category,
    setCategory,
    description,
    setDescription,
    expenseDate,
    setExpenseDate,
    handleCreateExpense,
    entityType
  };
};
